export default __webpack_public_path__ + "static/media/InProgressClock.040bbc7f.svg";